import React, { Component } from 'react';
import { autorun } from 'mobx';
import { Provider } from 'mobx-react';
import PubSub from 'pubsub-js';
import { lowerFirst, result } from 'lodash';

import PageState from 'js/stores/PageState';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import analytics from 'js/services/Analytics';

import OffsetManager from 'js/stores/OffsetManager';
import PageError from './PageError';
import SomethingWentWrong from './SomethingWentWrong';

export default class PageComponent extends Component {
  pageState = PageState.create();

  pageName = null;
  trackingName = null;
  pageColor = 'white';
  pageWidth = '400px';
  canReboot = true;
  loginRequired = false;
  rolesRequired = [];
  pageEvent = () => {};
  backNav = {
    mode: 'normal',
  };

  offsetManager = OffsetManager.create();

  _pageBooter = null;
  _bootPage = () => {
    // reset the state to defaults
    AppState.setCurrentPage(this.pageName).setPageColor(this.pageColor.hex ? this.pageColor.hex() : this.pageColor);

    // boot/initialize the page
    PubSub.publish('page-booting');
    if (typeof this.pageTitle !== 'function') {
      const title = this.pageTitle ? this.pageTitle : app.page_titles[lowerFirst(this.pageName)];
      document.title = `${title}${title ? ' - ' : ''}Pay On Delivery`;
    }
    this.pageState.bootPage(this.bootstrap).then(() => {
      if (window.app.env !== 'production') {
        // make thisPage store available on the window if not in production
        window.thisPage = this.page;
      }

      if (typeof this.pageTitle === 'function') {
        const title = this.pageTitle();
        document.title = `${title}${title ? ' - ' : ''}Pay On Delivery`;
      }

      AppState.setNav(result(this, 'backNav')).setBooted(true);

      this.page && this.page._markAsLoaded && this.page._markAsLoaded();

      analytics.page(this.trackingName || this.pageName, document.title, location.href);

      this.pageEvent();
    });
  };

  componentDidMount() {
    analytics.initialize(this.experiences);
    this.rebootSubscription = PubSub.subscribe('canReboot', (msg, canReboot) => (this.canReboot = canReboot));
    this._pageBooter = autorun(() => {
      if (!AppUser.isLoggingOut && (this.canReboot || !AppState.booted)) {
        AppState.setLoginRequired(this.loginRequired);
        AppState.setRolesRequired(this.rolesRequired);

        if (!this.rolesRequired.length || AppUser.hasRoles(this.rolesRequired)) {
          if (AppUser.isLoggedIn) {
            this._bootPage();
          } else if (!AppUser.isLoggedIn && !this.loginRequired) {
            this._bootPage();
          }
        }
      }
    });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.rebootSubscription);
    this._pageBooter();
  }

  constructor(props) {
    super(props);
    this.state = { pageHasFatalError: false };
    window.scrollTo(0, 0);
  }

  static getDerivedStateFromError(error) {
    return { pageHasFatalError: true };
  }

  render() {
    const { isBooting, error } = this.pageState;

    if (this.state.pageHasFatalError) {
      return <SomethingWentWrong />;
    }

    if (this.rolesRequired.length && !AppUser.hasRoles(this.rolesRequired)) {
      return (
        <Provider pageWidth={this.pageWidth} offsetManager={this.offsetManager}>
          <PageError error={{ status: AppUser.isLoggedIn ? 'Unauthorized' : 'Please login to continue' }} />
        </Provider>
      );
    }

    if (isBooting) {
      return this.renderLoading ? (
        this.renderLoading()
      ) : (
        <div className="loading-display">
          <img src="/images/spinner.svg"  alt={'Loading'}/>
        </div>
      );
    }

    if (!AppUser.isLoggedIn && AppState.loginRequired) {
      return null;
    }

    return (
      <Provider page={this.page} pageWidth={this.pageWidth} offsetManager={this.offsetManager}>
        {error ? <PageError error={error} /> : this.renderPage()}
      </Provider>
    );
  }
}
